/** @jsx jsx */
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import Slide from '@material-ui/core/Slide'
import {TransitionProps} from '@material-ui/core/transitions'
import React from 'react'
import {jsx} from 'theme-ui'
import {useTranslation} from 'react-i18next'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {children?: React.ReactElement<any, any>},
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />
})
type Props = {
  open: boolean
  handleYes: () => void
  handleNo: () => void
}

const CancelSubscriptionConfirmation: React.FC<Props> = ({
  open,
  handleYes,
  handleNo,
}) => {
  const {t} = useTranslation()
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleNo}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            sx={{
              color: 'black !important',
            }}
          >
            {t('cancellationMessage')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNo} color="primary">
            {t('NO')}
          </Button>
          <Button onClick={handleYes} color="primary">
            {t('YES')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default CancelSubscriptionConfirmation
